import api from './api';

export const feedbackService = {
  async submitFeedback(feedback) {
    try {
      const response = await api.post('/feedback-app', feedback);
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar feedback:', error);
      throw error;
    }
  },

  async getAllFeedbacks() {
    const response = await api.get('/feedback-app/listar');
    return response.data;
  },

  async updateFeedbackStatus(feedbackId, status) {
    const response = await api.patch(`/feedback-app/${feedbackId}/status`, { status });
    return response.data;
  },

  async respondToFeedback(feedbackId, response) {
    const res = await api.post(`/feedback-app/${feedbackId}/response`, { response });
    return res.data;
  },

  async deleteFeedback(feedbackId) {
    const response = await api.delete(`/feedback-app/${feedbackId}`);
    return response.data;
  }
};
